import * as React from 'react'
import {
  Box,
  Heading,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Divider,
  Stack,
  useColorModeValue as mode
} from '@chakra-ui/react'

export interface ChapterData {
  date: string
  name: string
  desc: string
  features: Array<{ name: string, desc: string }>
}

interface ChapterProps {
  data: ChapterData
}

export const Chapter = (props: ChapterProps) => {
  const { data, ...rest } = props
  const { date, name, desc, features } = data
  const accentColor = mode('blue.600', 'blue.200')

  return (
    <Box {...rest}>
      <Divider />
      <Stack
        direction={{ base: 'column', lg: 'row' }}
        spacing={{ base: '1rem', lg: '2rem' }}
        my="8"
        align={{ lg: 'top' }}
        justify="space-between"
        minH={{ base: '0', lg: '' }}
      >
        <Box flex="1" maxW={{ lg: '520px' }}>
          <Text
            size="xs"
            fontWeight="semibold"
            color={mode('blue.600', 'blue.600')}
          >
            {date}
          </Text>
          <Heading
            as="h3"
            size="xl"
            color={mode('gray.900', 'gray.600')}
            mt="1"
            fontWeight="extrabold"
            letterSpacing="tight"
            fontFamily="Tomato Grotesk"
            whiteSpace="pre-line"
          >
            {name}
          </Heading>
          <Text color={mode('gray.600', 'gray.400')} mt="4" fontSize="md" fontWeight="medium" whiteSpace="pre-line">
            {desc}
          </Text>
        </Box>
        <Box pos="relative" pt={{ base: '0', lg: '14px' }} pb={{ base: '20px', lg: '0' }} w={{ base: 'full', lg: '550px' }}>
          <Accordion defaultIndex={[]} allowToggle={true} allowMultiple={false}>
            {features.map((feature, index) => (
              <AccordionItem key={index}>
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left" fontWeight="bold">
                      {feature.name}
                    </Box>
                    {feature.desc && 
                      <AccordionIcon />
                    }
                  </AccordionButton>
                </h2>
                {feature.desc && 
                  <AccordionPanel pb={4}>
                    <Text whiteSpace="pre-line">
                      {feature.desc}
                    </Text>
                  </AccordionPanel>
                }
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      </Stack>
    </Box>
  )
}